module.exports = __webpack_public_path__ + "static/media/Assets-04-AB-dental-halftone.63f357b0.jpg";